import { useState } from 'react';
import { faqData } from '@/mocks/categories';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wider uppercase mb-3">
            Common Questions
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            Find answers to the most common questions about Vigorbuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/60 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </h3>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${openIndex === index ? 'bg-primary-100 rotate-45' : 'bg-background-100'}`}>
                  <i className={`text-sm ${openIndex === index ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-500'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer,
            },
          })),
        }),
      }} />
    </section>
  );
}